export default function (image, option, replaceHTTPS) {
  const imageService = '//img2.storyblok.com/'
  let replace = replaceHTTPS ? "https://a.storyblok.com" : "//a.storyblok.com";
  var path = image?.replace(replace, '')
  return imageService + option + path
}
